import { UserApiClient } from '@fourthwall/services/dist/UserApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useUserAccountSettingsMutation = createMutationHook(
  UserApiClient.updateUserAccountSettings,
  {
    mutationKey: ['userAccountSettings'],
  },
)
